import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import AnimatedCounter from "./AnimatedCounter";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FALLBACK = [
    { label: "Interviews Conducted", value: 10000, suffix: "+" },
    { label: "Data Accuracy", value: 95, suffix: "%" },
    { label: "Countries Served", value: 12, suffix: "+" },
    { label: "Expert Interviewers", value: 50, suffix: "+" },
];

export default function StatsStrip() {
    const [stats, setStats] = useState(FALLBACK);

    useEffect(() => {
        let mounted = true;
        axios
            .get(`${BACKEND_URL}/api/stats`)
            .then((r) => {
                if (mounted && Array.isArray(r.data) && r.data.length) {
                    setStats(r.data);
                }
            })
            .catch(() => {});
        return () => {
            mounted = false;
        };
    }, []);

    return (
        <section
            className="relative py-16 border-y border-white/5 bg-[#040A18]"
            data-testid="stats-strip"
        >
            <div className="absolute inset-0 bg-grid bg-grid-fade opacity-30 pointer-events-none" />
            <div className="pr-container relative grid grid-cols-2 lg:grid-cols-4 gap-8">
                {stats.map((s, i) => (
                    <motion.div
                        key={s.label}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: i * 0.08 }}
                        className="relative text-center lg:text-left"
                        data-testid={`stat-card-${i}`}
                    >
                        <div className="font-outfit text-5xl sm:text-6xl font-black tracking-tighter text-white text-glow-blue">
                            <AnimatedCounter
                                to={s.value}
                                suffix={s.suffix || ""}
                                prefix={s.prefix || ""}
                                testId={`stat-value-${i}`}
                            />
                        </div>
                        <p className="mt-3 font-outfit text-xs uppercase tracking-[0.25em] text-blue-400 font-bold">
                            {s.label}
                        </p>
                        <div className="mt-3 h-px bg-gradient-to-r from-blue-500/40 via-emerald-400/30 to-transparent w-full" />
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
